import React from 'react';
import SingleRatesInfo from './single-rates-info.jsx';
import { connect } from 'react-redux';
import R from 'ramda';
import { checkIfProductWithNothingToShow } from '../../../../../utils/mass-rate-change-helpers';

const SingleProduct = ({ productName, ratePackageName, updateType, rateType,...extraProps }) => {
  return (
    <div style={{ marginTop: '16px' }}>
      <div style={{
        height: '48px',
        textOverflow: 'ellipsis',
        overflowX: 'hidden',
        whiteSpace: 'pre',
        textTransform: 'uppercase',
        lineHeight: '48px',
        fontWeight: 'bold',
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
        borderBottom: 'solid 1px #eeeeee',
      }}
      >
        {productName} { ratePackageName ? ` - ${ratePackageName}` : '' }
      </div>
      {
        R.equals(updateType, 'seasonRates') ? R.compose(
          seasonRates => seasonRates.map((seasonRate, index) => <SingleRatesInfo {...seasonRate} ratePackageName={ratePackageName} key={index} />),
          R.propOr([], 'seasonRates')
        )(extraProps) : R.compose(
          rateSets => rateSets.map((rateSet, index) => <SingleRatesInfo {...rateSet} ratePackageName={ratePackageName} key={index} />),
          R.pathOr([], [updateType, rateType])
        )(extraProps)
      }
    </div>
  );
};

const mapStateToProps = ({ contracting }) => ({
  updateType: contracting.massRateChange.get('updateType'),
  rateType: contracting.massRateChange.get('rateType'),
});

export default connect(mapStateToProps)(SingleProduct);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/rates-detail/single-product/single-product.jsx